export default {
  viewAllResources: 'View All Resources',
  clearCategoriesFilters: 'Clear All Categories Filters',
  loading: 'Loading data...',
  errorLoading: 'Error Loading Data',
  tryAgain: 'Try Again',
  noDataFound: 'No Data Found',
  tryAdjustingFilters: 'Try adjusting your search or filters.',
};
